/* eslint-disable no-param-reassign */
import { useState, useCallback } from 'react';
import api from '~/services';
import log from '~/helpers/log';

export default function usePlayRecord(value = null) {
  const [callRecord, setAudioUrl] = useState(value);

  const setPlayRecord = useCallback(async id => {
    try {
      const record = await api.calls.get.record(id, 'mp3');
      const blob = new Blob([record.data], { type: 'audio/mp3' });
      const url = window.URL.createObjectURL(blob);
      setAudioUrl(url);

      // // create audio context
      // const audioContext = new AudioContext();
      // // create audioBuffer (decode audio file)
      // const audioBuffer = await audioContext.decodeAudioData(record.data);

      // // create audio source
      // const source = audioContext.createBufferSource();
      // source.buffer = audioBuffer;
      // source.connect(audioContext.destination);

      // play audio
      // source.start();
    } catch (err) {
      log.error('Failed to play call record.', err);
    }
  }, []);

  return [{ callRecord }, setPlayRecord];
}
